import React from "react";
import { Button, Modal, Col, Row } from "antd";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const BookingWarningComponent = observer((props) => {

	// reset form and close add form
	const close = () => {
		props.close();
	};

	return (
		<Modal
			centered
			className={props.className? props.className : "statusModal"}
			title={props.title}
			open={props.visible}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			onCancel={props.close}
			cancelButtonProps={{ style: { display: "none" } }}
			okButtonProps={{ style: { display: "none" } }}
			zIndex={1001}
			footer={[
				<Button
					key="2"
					htmlType="button"
					className="cancelBtn mr-35"
					onClick={close}
				>
					Ok
				</Button>
			]}
			//footer={false}
		>
			<Row align="middle">
				<Col span={24} className="text-center">
					<h3>
						<span><FontAwesomeIcon icon={faExclamationTriangle} /></span> {props.messages}
					</h3>
				</Col>
			</Row>
		</Modal>
	);
});

export default BookingWarningComponent;